'use strict';

(function ($) {
  var methods = {
    init: function (options) {
      // options are not used
      var opts = $.extend({}, $.fn.k2_alerts.defaults, options);

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('alerts-init')) {
          return;
        }

        $this.addClass('alerts-init');

        $this.on('click', '.alert-close-btn', function () {
          methods.close.apply(_this);
          return false;
        });

        if (opts.autoCloseAlerts.indexOf($this.data('type')) >= 0 && !$this.data('stayonmonitor')) {
          $this.find('.alert-countdown-wrapper').show();
          $this.find('.alert-countdown').k2_countdown({
            intervalStep: 250,
            duration: opts.autoCloseTimeout,
            callback: function () {
              methods.close.apply(_this);
            }
          });
        }
      });
    },

    close: function () {
      var _this = this;
      var $this = $(this);

      $this.hide();

      $('body').trigger('alert-closed');

      return _this;
    }
  };

  $.fn.k2_alerts = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_alerts');
    }

  };

  $.fn.k2_alerts.defaults = {
    autoCloseTimeout: 5000, //ms
    autoCloseAlerts: ['success', 'warning', 'danger']
  };

})(jQuery);
